import { render, staticRenderFns } from "./CarbonEmssionByTop.vue?vue&type=template&id=8942924c&scoped=true&"
import script from "./CarbonEmssionByTop.vue?vue&type=script&lang=js&"
export * from "./CarbonEmssionByTop.vue?vue&type=script&lang=js&"
import style0 from "./CarbonEmssionByTop.vue?vue&type=style&index=0&id=8942924c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8942924c",
  null
  
)

export default component.exports